import slate from '../packages/plugins/content/slate';

const defaultSlate = slate();

const columnsTablePlugin: any = {
  Renderer: ({ children, data }: any) => (
    <div
      className="columnsTable-content"
      style={{
        // display: "flex",
        background: data?.backgroundColor,
        padding: '9px 11px',
        borderRadius: '50px',
        maxWidth: '600px',
        minWidth: '400px',
        margin: '0 auto',
      }}
    >
      {children}
    </div>
  ),
  createInitialChildren: () => {
    return [
      [
        {
          plugin: defaultSlate,
          data: defaultSlate.createData(({ plugins }) => ({
            children: [
              {
                plugin: plugins.headings.h3,
                children: ['List 1'],
                data: { test: '123' },
              },
            ],
          })),
        },
        {
          plugin: defaultSlate,
          data: defaultSlate.createData(({ plugins }) => ({
            children: [
              {
                plugin: plugins.headings.h3,
                children: ['List 2'],
              },
            ],
          })),
        },
      ],
    ];
  },

  id: 'columnsTable-plugin',
  title: 'Column List Box',
  // description: 'emergency content plugin',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      required: ['backgroundColor'],
      properties: {
        backgroundColor: {
          type: 'string',
          default: '#ededf6',
        },
      },
    },
  },
};

export default columnsTablePlugin;
